import * as React from "react"
import { Link } from 'gatsby'
import { useState, useRef } from "react"
import { categoryDiscover } from '@/service/api'
import { useEffect } from "react"
import categoryArrow from '@/images/category_arrow.png'
import * as cs from './category-pc.module.scss'
import SEO from '@/templates/seo'
import Loading from '@/layouts/Loading'
interface sort {
  label: string,
  id: null | string
}
const availableSorts: sort[] = [
  { label: '默认排序', id: null },
  { label: '销量从高到低', id: 'sales' },
  { label: '折扣从高到低', id: 'discount' },
  { label: '价格从高到低', id: 'priceDescTag' },
  { label: '价格从低到高', id: 'priceAscTag' }
]

const size = 16;

const CategoryPC = (props: any) => {
  const { cid, name, product } = props;
  const _product = { ...product }
  let { productList: _productList, total: _total } = _product
  if (_productList) {
    _productList = _productList?.filter((product: any) => product.type == "PRODUCT")
    _productList = _productList.slice(0, size)
  }
  const [products, setProducts] = useState<null | Array<any>>(_productList)
  const [total, setTotal] = useState<null | number>(_total)
  const [sort, changeSort] = useState(availableSorts[0])
  const [from, setFrom] = useState(0)
  const [showLoading, setShowLoading] = useState(false)
  const [discountRange1, changeDiscountRange1] = useState<undefined | string>(undefined)
  const [discountRange2, changeDiscountRange2] = useState<undefined | string>(undefined)
  const [priceRange1, changePriceRange1] = useState<undefined | string>(undefined)
  const [priceRange2, changePriceRange2] = useState<undefined | string>(undefined)
  const [SEO_Title,] = useState(() => getTitle())
  const [SEO_Des,] = useState(() => getDes())
  const [SEO_Keywords,] = useState(() => getKeyWords())

  const discountRef1 = useRef<HTMLInputElement>(null)
  const discountRef2 = useRef<HTMLInputElement>(null)
  const discountRef3 = useRef<HTMLInputElement>(null)
  const discountRef4 = useRef<HTMLInputElement>(null)

  const priceRef1 = useRef<HTMLInputElement>(null)
  const priceRef2 = useRef<HTMLInputElement>(null)
  const priceRef3 = useRef<HTMLInputElement>(null)
  const priceRef4 = useRef<HTMLInputElement>(null)

  useEffect(() => {
    onSave()
  }, [sort])

  useEffect(() => {
    search();
  }, [from])


  const search = () => {
    setShowLoading(true)
    let q = `f=${from * size}&t=${(from + 1) * size}&cids=${cid}`
    if (sort && sort.id) q += `&s=${sort.id}`
    if (priceRange1 && priceRange2) {
      q += `&prs=${Number(priceRange1) * 100}-${Number(priceRange2) * 100}`
    } else if (priceRange1) {
      q += `&prs=${Number(priceRange1) * 100}-`
    } else if (priceRange2) {
      q += `&prs=0-${Number(priceRange2) * 100}`
    }
    let _discountRange1 = Number(discountRange1) || 0;
    let _discountRange2 = Number(discountRange2) || 100;
    if (_discountRange1 < 0) _discountRange1 = 0
    if (_discountRange2 > 10) _discountRange2 = 10
    q += `&dr=${100 - _discountRange2 * 10}-${100 - _discountRange1 * 10}`
    categoryDiscover(q)
      .then((res: any) => {
        setShowLoading(false)
        let productList = res.products
        productList = productList.filter((product: any) => product.type == "PRODUCT")
        productList = productList.slice(0, size)
        if (from) {
          setProducts(products!.concat(productList))
        } else {
          setProducts(productList)
        }
        setTotal(res?.total)
      }).catch(err => {
      })
  }


  const changeInput = (e: React.ChangeEvent<HTMLInputElement>, cb: Function, type: string) => {
    let value = e.target.value.trim()
    value = value.replace(/[^0-9.]/g, '')
    if (type === 'discount' && Number(value) > 10) {
      return
    }
    cb(value)
  }
  const onSave = () => {
    if (priceRange1 && priceRange1 !== '$' && !priceRange2) changePriceRange2('$')
    if (!priceRange1 && priceRange2 && priceRange2 !== '$') changePriceRange1('$')
    if ((!priceRange1 || priceRange1 === '$') && (!priceRange2 || priceRange2 === '$')) {
      resetPrice()
    }
    if (discountRange1 && discountRange1 !== '0折' && !discountRange2) changeDiscountRange2('全价')
    if (!discountRange1 && discountRange2 && discountRange2 !== '全价') changeDiscountRange1('0折')
    if ((!priceRange1 || priceRange1 === '0折') && (!priceRange2 || priceRange2 === '全价')) {
      resetPrice()
    }
    if (from === 0) {
      search()
    } else {
      setFrom(0)
    }
    // 加个loading
  }

  const resetDiscount = () => {
    changeDiscountRange1(undefined);
    changeDiscountRange2(undefined);
    discountRef1.current!.value = ''
    discountRef2.current!.value = ''
    discountRef3.current!.value = ''
    discountRef4.current!.value = ''
  }

  const resetPrice = () => {
    changePriceRange1(undefined);
    changePriceRange2(undefined);
    if (priceRef1.current) { priceRef1.current.value = ''; }
    if (priceRef2.current) { priceRef2.current.value = ''; }
    if (priceRef3.current) { priceRef3.current.value = ''; }
    if (priceRef4.current) { priceRef4.current.value = ''; }
  }

  function getTitle() {
    return `别样海外购_${name?.[name?.length - 1]?.value ?? ''}商品类目频道 | 别样海外购 bieyangapp.com`
  }

  function getDes() {
    let brands = ''
    let merchants = ''
    _productList?.map((item: any, index: number) => {
      if (index < 6) {
        brands += `${item?.searchProduct?.product?.brand || ""}、`;
        merchants += `${item?.searchProduct?.merchantName || ""}、`;
      }
    })

    return `别样海外购是一个欧美时尚商品海淘直购的电商平台，同时也包含多个商品类目，当前类目属于${name?.[name?.length - 1]?.value ?? ''}, 其中包含${brands}等品牌，${merchants}等商家。`
  }

  function getKeyWords() {
    let res = '别样、'
    name?.map((item: any) => res += `${item.value} 、`)
    _productList?.map((item: any, index: number) => {
      if (index < 6) {
        const { nameCN, brand } = item?.searchProduct?.product || {}
        if (nameCN) res += `${nameCN}、`
        if (brand) res += `${brand}、`
      }
    })
    return res
  }

  return (
    <div className={cs.category}>
      {showLoading && <Loading />}
      <SEO
        title={SEO_Title}
        description={SEO_Des}
        keywords={SEO_Keywords}
      />
      <div className={cs.categoryStep}>
        {
          name.map((item: any, index: number) => {
            return <span key={index}>
              <Link to={item.path}><span>{item.value}</span> </Link>
              {
                index < name.length - 1 ? <img className={cs.categoryStepArrow} src={categoryArrow} /> : <></>
              }
            </span>
          })
        }
      </div>
      <h1 className={cs.categoryTitle}>{name[name.length - 1].value}</h1>
      <div className={cs.categoryBar}>
        <div className={cs.categoryBarLeft}>
          <div className={cs.categoryBarLeftSort}>
            <span className={cs.categoryBarLeftSortText}>{sort.label}</span>
            <div className={cs.categoryBarLeftSortHoverBg}>
              <ul className={cs.categoryBarLeftSortHover}>
                {
                  availableSorts.map((item: sort) => {
                    return <li
                      key={item.label}
                      className={sort.label === item.label ? cs.categoryBarLeftSortHoverCurrent : ''}
                      onClick={() => { changeSort(item) }}
                    >{item.label}</li>
                  })
                }
              </ul>
            </div>
          </div>
          <div className={cs.categoryBarLeftPrice}>
            <span>价格：</span>
            <input ref={priceRef1} type="text" name="最小价格" placeholder='$' value={priceRange1} autoComplete='off' />
            <span className={cs.categoryBarLeftPriceLine}></span>
            <input ref={priceRef2} type="text" name="最高价格" placeholder='$' value={priceRange2} autoComplete="off" />
            <div className={cs.categoryBarLeftPriceHover}>
              <div className={cs.categoryBarLeftPriceHoverTop}>
                <span>价格：</span>
                <input ref={priceRef3} type="text" name="最小价格" placeholder='$' value={priceRange1}
                  onChange={(e) => { changeInput(e, changePriceRange1, 'price') }}
                  autoComplete="off" />
                <span className={cs.categoryBarLeftPriceLine}></span>
                <input ref={priceRef4} type="text" name="最高价格" placeholder='$' value={priceRange2}
                  onChange={(e) => { changeInput(e, changePriceRange2, 'price') }}
                  autoComplete="off" />
              </div>
              <div className={cs.categoryBarLeftPriceHoverBtns}>
                <span onClick={resetPrice}>清除</span><span onClick={onSave}>确定</span>
              </div>
            </div>
          </div>
          <div className={cs.categoryBarLeftDiscount}>
            <span>折扣：</span>
            <input ref={discountRef1} type="text" name='最低折扣' placeholder='0折' value={discountRange1 && discountRange1 !== '0折' ? discountRange1 + '折' : discountRange1} autoComplete="off" />
            <span className={cs.categoryBarLeftDiscountLine}></span>
            <input ref={discountRef2} type="text" name='最高折扣' placeholder='全价' value={discountRange2 && discountRange2 !== '全价' ? discountRange2 + '折' : discountRange2} autoComplete="off" />
            <div className={cs.categoryBarLeftDiscountHover}>
              <div className={cs.categoryBarLeftDiscountHoverTop}>
                <span>折扣：</span>
                <input maxLength={3} ref={discountRef3} type="text" name='最低折扣' placeholder='0折' value={discountRange1}
                  onChange={(e) => { changeInput(e, changeDiscountRange1, 'discount') }}
                  autoComplete="off" />
                <span className={cs.categoryBarLeftDiscountLine}></span>
                <input maxLength={3} ref={discountRef4} type="text" name='最高折扣' placeholder='全价' value={discountRange2}
                  onChange={(e) => { changeInput(e, changeDiscountRange2, 'discount') }}
                  autoComplete="off" />
              </div>
              <div className={cs.categoryBarLeftDiscountHoverBtns}>
                <span onClick={resetDiscount}>清除</span><span onClick={onSave}>确定</span>
              </div>
            </div>
          </div>
        </div>
        <div className={cs.categoryBarRight}>共{total}件商品</div>
      </div>
      <section className={cs.categorySection}>
        {
          products?.map((item: any, idx: number) => {
            return (
              <a key={idx} className={cs.categoryProduct} href={`/product/${item?.searchProduct?.product?.id}/`}>
                <div className={cs.categoryProductImg}>
                  <img src={item?.searchProduct?.product?.images[0]?.thumbnail?.url || item?.searchProduct?.product.images[0].full.url} alt={`商品${item.name || item.nameCN || item.searchProduct.product.nameCN || item.searchProduct.product.name}图片`} />
                </div>
                <div className={cs.categoryProductName}>{item?.searchProduct?.product.brandCN || item?.searchProduct?.product.brand} | {item?.searchProduct?.product.nameCN || item.searchProduct.product.name}</div>
                <div className={cs.categoryProductOrigin}>
                  {item.searchProduct.origin}{item.searchProduct.merchantName}
                </div>
                <div className={cs.categoryProductPrice}>
                  <span className={cs.categoryProductPriceCn}>{item.searchProduct.product.priceTagCN}</span>
                  <span className={cs.categoryProductPriceEn}>{item.searchProduct.product.priceTag}</span>
                </div>
                <div className={cs.categoryProductTag}>
                  {
                    item.searchProduct.activityOffs?.map((off: string, index: number) => {
                      return <div key={off}>
                        <span>{off}</span>
                        {(index === item.searchProduct.activityOffs.length - 1 && !item.searchProduct.off) ? <></> : <span className={cs.categoryProductTagLine}></span>}
                      </div>
                    })
                  }
                  <div>{item.searchProduct.off}</div>
                </div>
              </a>
            )
          })
        }
      </section>
      <div className={cs.categoryLoadMore} onClick={() => setFrom(from + 1)}>查看更多</div>
    </div>
  )
}

export default CategoryPC
